import {
  Button,
  Stack,
  Box,
  Slide,
  CircularProgress,
  Grow,
  Zoom,
} from "@mui/material";
import React, { useEffect } from "react";
import { tease } from "../components/CheckButton";
import { Color, FontStyle, navPaddingTop, Slug } from "../constants";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Confetti from "../components/Confetti";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
  },
  container: {
    // marginTop: '67px',
    paddingTop: { xs: "1rem", sm: "3rem" },
    paddingBottom: "110px",
    px: { xs: 0, sm: 4 },
    // backgroundColor: Color.primary,
    backgroundColor: "#fff",
    height: "100%",
    display: "flex",
    alignItems: "stretch",
    minHeight: "calc(100vh - 67px)",
  },
  inner: {
    width: "100%",
    // maxWidth: '350px',
    maxWidth: "350px",
    mx: "auto",
    textAlign: "center",
    //show overflow
    overflow: "visible",
  },
  heading: {
    ...FontStyle.title,
    fontSize: "2.8rem",
    minWidth: { xs: 0, sm: "450px" },
  },
  body: {
    ...FontStyle.body,
    fontSize: "1.2rem",
    opacity: 0,
    transition: "opacity 2s",
  },
  visible: {
    opacity: 1,
  },
  loaderbar: {
    width: "100%",
    height: "10px",
    backgroundColor: "#fff",
    borderRadius: "4px",
    // py: 2,
  },
  loaderbarInner: {
    height: "100%",
    backgroundColor: "rgb(96,208,138)",
    borderRadius: "4px",
  },
  endButtonDefault: {
    ...FontStyle.headingBody,
    fontSize: "1rem",
    textTransform: "none",
    transition: "all 0.4s ease-in-out 0s",
    height: "2.8rem",
  },
  endButton: {
    ...FontStyle.headingBody,
    backgroundColor: Color.mainGreen,
    // backgroundColor: '#3BF77A',
    color: "black",
    // borderRadius: '6.25rem',
    // border: `1px solid ${Color.mainGreen}`,
    "&:hover": {
      // backgroundColor: Color.primaryDark,
      backgroundColor: Color.darkGreen,
      boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
      // color: 'white',
    },
    // dropshadow
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
  },
  button: {
    ...FontStyle.headingBody,
    // backgroundColor: '#fff',
    backgroundColor: Color.primary,
    fontSize: "1rem",
    textTransform: "none",
    color: "black",
    // borderRadius: '6.25rem',
    padding: "0.69rem 2rem",
    opacity: 0,
    "&:hover": {
      animation: `${tease()} 0.3s ease-in-out 0s`,
      backgroundColor: Color.primary,
    },
    transition: "all 0.4s ease-in-out 0s",
  },
  bubble: {
    padding: "0.5rem 1rem",
    marginRight: "0.3rem",
    borderRadius: "6.25rem",
  },
};

const Results = () => {
  const [tx, setTx] = React.useState(0);
  const [timer, setTimer] = React.useState(null);
  useEffect(() => {
    if (timer) return;
    setTimer(
      setInterval(() => {
        setTx((prev) => prev + 1 / 60 / 5);
      }, 1000 / 60)
    );
  }, [timer]);
  useEffect(() => {
    if (tx >= 1) {
      clearInterval(timer);
    }
  }, [tx]);
  return (
    <Box sx={styles.outer}>
      <Confetti />
      {/* <Zoom in={tx > 0.05} timeout={800}> */}
      <Slide direction="down" in={tx > 0.05} timeout={800}>
        <Box sx={styles.container}>
          <Stack
            sx={styles.inner}
            direction="column"
            alignItems="center"
            spacing="1rem">
            {/* <Box sx={styles.heading}>You're all set 🎉</Box> */}
            <Box sx={styles.heading}>Let’s 👏 do 👏 this 👏</Box>
            <Box sx={styles.loaderbar}>
              <Box
                sx={{
                  ...styles.loaderbarInner,
                  width: `${tx * tx * tx * 100}%`,
                }}
              />
            </Box>
            {/* <Slide direction='left' in={tx > 0.1} timeout={200}> */}
            <Box
              sx={{
                ...styles.body,
                maxWidth: "300px",
                ...(tx > 0.1 && styles.visible),
              }}>
              {/* We're finding the <span style={{ fontWeight: 'bold' }}>ten best</span> matches for your preferences... */}
              Adding your ten best matches to your profile...
            </Box>
            <Stack
              spacing="1rem"
              direction="column"
              alignItems="center"
              sx={{ paddingTop: "1rem", paddingBottom: 0.5 }}>
              {/* <Box sx={{ ...styles.body, ...(tx > 0.3 && styles.visible) }}><span style={{ ...styles.bubble, border: '1px solid black' }}><FavoriteIcon sx={{ position: 'relative', top: '5px' }} /> Save</span> jobs you like</Box> */}
              <Box sx={{ ...styles.body, ...(tx > 0.3 && styles.visible) }}>
                👀 Ready to apply? Check them out now!
              </Box>
              {/* <Box sx={{ ...styles.body, ...(tx > 0.5 && styles.visible) }}><span style={{ ...styles.bubble, backgroundColor: '#fff' }}><BorderColorIcon sx={{ position: 'relative', top: '3px', width: '20px', height: '20px' }} /> Apply</span> to jobs you love</Box> */}
              <Box sx={{ ...styles.body, ...(tx > 0.5 && styles.visible) }}>
                🤝 Tap into our braintrust of recruiters from companies like
                Meta, Uber, and Google.
              </Box>
              <Box sx={{ ...styles.body, ...(tx > 0.7 && styles.visible) }}>
                ❤️ Connect with us on social media and stay in the loop for new
                job opportunities.
              </Box>
            </Stack>

            <Stack
              spacing="1.4rem"
              direction="column"
              alignItems="center"
              sx={{ paddingTop: 1, paddingBottom: 0.5 }}>
              {/* <Box sx={{ ...styles.body, ...(tx > 0.7 && styles.visible) }}>Applying to jobs helps us improve your recommendations.</Box> */}
              <Button
                sx={{
                  ...styles.button,
                  ...(tx > 0.95 && styles.visible),
                }}
                href={Slug.jobResults}>
                MEET YOUR NEW JOB
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Slide>
      {/* </Zoom> */}
    </Box>
  );
};

export default Results;
